import { Component } from '@verndale/core';

class Table extends Component {
  setupDefaults() {
    this.wrapTable();
  }

  wrapTable() {
    this.el.outerHTML = `<div class='table__wrapper' tabindex="0">${this.el.outerHTML}</div>`;
  }
}

export default Table;
